import React from "react";
import { Redirect } from "react-router-dom";
import { AI_SEARCH_URL } from "../utils/routes";
import { getUserDetails } from "../core/storage/localStorage";

function AuthGuard({ children }) {
  const user = getUserDetails();
  if (user) {
    return <Redirect to={AI_SEARCH_URL} />;
  }

  return children;
}

export default AuthGuard;
